import React from 'react';
export const ShavingNeeds = ({
  color = 'currentColor',
  width = '18px',
  height = '18px',
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Group 17'>
        <g data-name='Group 16'>
          <path
            data-name='Path 60'
            d='M17.24.609h-5.239a.741.741 0 00-.731.731v.667a.741.741 0 00.731.731h.183a1.222 1.222 0 011.222 1.222v1.222l-.152 3.351h2.777l-.183-3.351V3.959a1.222 1.222 0 011.222-1.222h.183a.741.741 0 00.731-.731v-.667a.741.741 0 00-.744-.731zm-2.011 4.265h-1.222v-.609h1.222zm.03-1.222h-1.28a1.741 1.741 0 00-.457-.914h2.163a1.952 1.952 0 00-.425.92z'
            fill={color}
          />
        </g>
      </g>
      <g data-name='Group 19'>
        <g data-name='Group 18'>
          <path
            data-name='Path 61'
            d='M16.023 9.138h-2.8l-.061 1.222h2.924z'
            fill={color}
          />
        </g>
      </g>
      <g data-name='Group 21'>
        <g data-name='Group 20'>
          <path
            data-name='Path 62'
            d='M16.413 16.144l-.243-5.178h-3.046l-.243 5.178a1.768 1.768 0 103.533 0z'
            fill={color}
          />
        </g>
      </g>
      <g data-name='Group 23'>
        <g data-name='Group 22'>
          <path
            data-name='Path 63'
            d='M8.499 1.827V0H2.436v2.742h-.918V4.11A2.283 2.283 0 000 6.274V7.31h6.092v7.31H0v1.066a2.3 2.3 0 002.284 2.285h3.934a2.282 2.282 0 002.284-2.284V6.244a2.312 2.312 0 00-1.526-2.163V2.742h-.915v-.915zM6.092 3.351h.3v.609h-4.26v-.609z'
            fill={color}
          />
        </g>
      </g>
      <g data-name='Group 25'>
        <g data-name='Group 24'>
          <path
            data-name='Path 64'
            d='M0 7.92v1.222h2.132a.304.304 0 110 .609H0v.914h3.655a.304.304 0 110 .609H0v.914h3.655a.304.304 0 110 .609H0v1.222h5.482V7.927z'
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};
